import { Injectable } from '@angular/core';
import {
  GetListStowageComplianceReportParams,
  GetShiftObservationReportUrlParams,
  Report,
  ReportRepository,
} from '@app/domain';
import { FileData, PaginatedResponse } from '@app/shared/models/global.model';
import { map, Observable } from 'rxjs';
import { ReportService } from '../api-clients';
import { ReportMapper } from '../mappers';

@Injectable()
export class ReportRepositoryImpl implements ReportRepository {
  private readonly _reportMapper = new ReportMapper();

  constructor(private readonly _reportService: ReportService) {}

  getShiftObservationsReportURL(
    params: GetShiftObservationReportUrlParams
  ): Observable<string> {
    const urlDto = this._reportService.getShiftObservationsReportURL(params);

    return urlDto.pipe(
      map(dto => this._reportMapper.shiftObservationReportUrlToDomain(dto))
    );
  }

  getListStorageComplianceReport(
    params: GetListStowageComplianceReportParams
  ): Observable<PaginatedResponse<Report>> {
    const dtos = this._reportService.getListStorageComplianceReport(params);

    return dtos.pipe(
      map(dto => this._reportMapper.listStowageComplianceReportToDomain(dto))
    );
  }

  downloadStorageComplianceReport(
    vesselByShiftId: number
  ): Observable<FileData> {
    const dtos =
      this._reportService.downloadStorageComplianceReport(vesselByShiftId);

    return dtos.pipe(map(dto => dto));
  }
}
